import { BaseModalComponent } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { BORDER_RADIUS } from 'parkway-web-common'
import { HookFormCommon } from '../hook'
import { useHook } from './hook'

export const CreateModalLayout = () => {
  const { form, modalRef, handleSubmit, isLoading } = useHook()
  return (
    <BaseModalComponent
      titleModal={'Tạo mới công đoàn bộ phận'}
      titleOpenModal={'Tạo mới'}
      ref={modalRef}
      handleSubmit={form?.submit}
      borderRadiusButtonOpen={BORDER_RADIUS}
      borderButtonOpen={`1px solid ${convertedVariables.neutralBlack9Color}`}
      styleButtonOpen={{
        backgroundColor: convertedVariables?.backgroundColor,
      }}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <HookFormCommon />
        </BaseForm>
      }
    />
  )
}
